import { notifyError } from '../components/Toast';
import { fetchWithAuth } from '../auth/fetchWithAuth';
import CAREERS_BLACK_LIST from '../enums/CareersBlackList';
import FACULTIES_BLACK_LIST from '../enums/FacultiesBlackList';

export const GetAllCarreras = (carreras, facultades, sede = null, user) => {
  return async (dispatch) => {
    dispatch({ type: 'GET_ALL_CARRERAS_REQUEST' });
    try {
      const params = new URLSearchParams();
      params.append('carreras', Array.isArray(carreras) ? carreras.join(',') : (carreras || ''));
      params.append('facultades', Array.isArray(facultades) ? facultades.join(',') : (facultades || ''));
      params.append('sede', sede || '');

      const response = await fetchWithAuth(`${process.env.REACT_APP_API_BASE_URL}sigue/carreras?${params.toString()}`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': 'Bearer ' + user.token
        },
      }, dispatch);

      if (response.ok) {
        const data = await response.json();
        
        const structuredData = Object.values(
          data
            .filter((d) =>
              (d.SedeId.trim() === 'ROS' || d.SedeId.trim() === 'BUE' || d.SedeId.trim() === 'ULTRA') &&
              !CAREERS_BLACK_LIST.includes(d.Id)
            )
            .map((d) => ({
              codFacultad: d.FacultadId,
              codCarrera: d.Id,
              descripcion: d.Descripcion,
              ciclo: d.Ciclo,
              sede: d.SedeId// === 'ULTRA' ? 'BUE' : d.sede,
            }))
            .reduce((acc, carrera) => {
              const key = `${carrera.codFacultad}-${carrera.codCarrera}-${carrera.sede}`;
              if (!acc[key]) {
                acc[key] = carrera;
              }
              return acc;
            }, {})
        );

        dispatch({ type: 'GET_ALL_CARRERAS_SUCCESS', payload: structuredData });
      } else {
        const errorData = await response.text();
        dispatch({ type: 'GET_ALL_CARRERAS_FAIL', payload: errorData });
      }
    } catch (error) {
      dispatch({ type: 'GET_ALL_CARRERAS_FAIL', payload: error.message });
    }
  }
};

export const GetAllSchoolCareers = (cod, user) => {
  return async (dispatch) => {
    dispatch({ type: 'GET_ALL_FACULTADES_CARRERAS_REQUEST' });
    try {

      const params = new URLSearchParams();
      params.append('codigo', cod || '');

      const response = await fetchWithAuth(`${process.env.REACT_APP_API_BASE_URL}reportes/facultades/carreras?${params.toString()}`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': 'Bearer ' + user.token
        },
      }, dispatch);

      if (response.ok) {
        const data = await response.json();

        const structuredData = data
        .filter((fac) => !FACULTIES_BLACK_LIST.includes(fac.codFacultad.toUpperCase()))
        .map((fac) => ({
          codFacultad: fac.codFacultad,
          descripcion: fac.descripcion,
          carreras: fac.carreras
            .filter((d) => !CAREERS_BLACK_LIST.includes(d.Id.toUpperCase()))
            .map((d) => ({
              codCarrera: d.Id,
              descripcion: d.Descripcion,
              ciclo: d.Ciclo?.trim(),
              cicloDescripcion: d.CicloDescripcion,
              sede: d.SedeId?.trim(),
            })),
          })
        );

        dispatch({ type: 'GET_ALL_FACULTADES_CARRERAS_SUCCESS', payload: structuredData });
      } else {
        const errorData = await response.text();
        dispatch({ type: 'GET_ALL_FACULTADES_CARRERAS_FAIL', payload: errorData });
      }
    } catch (error) {
      dispatch({ type: 'GET_ALL_FACULTADES_CARRERAS_FAIL', payload: error.message });
    }
  }
};

function transformarUsuarios(data) {
  const sedeGenerica = {
    Id: "00000000-0000-0000-0000-000000000001",
    codigo: "GEN",
    descripcion: "Todas las sedes"
  };

  const isFacultad = data.some(u =>
    u.permisos.some(p => p.permiso?.categoria?.codigo?.toLowerCase() === 'facultad')
  );

  const resultado = {};

  data.forEach(usuario => {
    usuario.permisos.forEach(p => {
      const sede = isFacultad ? sedeGenerica : p.sede;
      const cargo = p.cargo;

      if (!resultado[sede.codigo]) {
        resultado[sede.codigo] = {
          Id: sede.Id,
          codigo: sede.codigo,
          descripcion: sede.descripcion,
          cargos: []
        };
      }

      const sedeObj = resultado[sede.codigo];

      let cargoObj = sedeObj.cargos.find(c => c.Id === cargo.Id);
      if (!cargoObj) {
        cargoObj = {
          Id: cargo.Id,
          codigo: cargo.codigo,
          descripcion: cargo.descripcion,
          usuarios: []
        };
        sedeObj.cargos.push(cargoObj);
      }

      if (!cargoObj.usuarios.find(u => u.userId === usuario.userId)) {
        cargoObj.usuarios.push({
          userId: usuario.userId,
          nombre: usuario.nombre,
          apellido: usuario.apellido,
          mail: usuario.mail
        });
      }
    });
  });

  return resultado;
}

export const GetAcademicUnitUserPositions = (unitId,user) => {
  return async (dispatch) => {
    dispatch({ type: 'GET_ACADEMIC_USERS_POSITIONS_REQUEST' });
    try {

      const response = await fetchWithAuth(
        `${process.env.REACT_APP_API_BASE_URL}reportes/permisos/${unitId}/usuarios`, 
        {
          method: 'GET',
          headers: {
            'Content-Type': 'application/json',
            'Authorization': 'Bearer ' + user.token
          },
        },
        dispatch
      );
    
      if(response.ok){
        const data = await response.json();
        const reorganizedData = transformarUsuarios(data);
        
        dispatch({ type: 'GET_ACADEMIC_USERS_POSITIONS_SUCCESS', payload: reorganizedData });
        
      } else{
        const errorData = await response.json();
        dispatch({ type: 'GET_ACADEMIC_USERS_POSITIONS_FAIL', payload: errorData.message || 'Error desconocido' });
        notifyError('Error al obtener los usuarios de la unidad académica');
      }

    } catch (error) {
      dispatch({ type: 'GET_ACADEMIC_USERS_POSITIONS_FAIL', payload: error.message });
    }
  };
};
